import { render, staticRenderFns } from "./PapercleanDizionariTipiListComponent.vue?vue&type=template&id=45de0510"
import script from "./PapercleanDizionariTipiListComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanDizionariTipiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports